<div
  class="w-9 h-9 flex items-center justify-center hover:bg-translucent-200A rounded-md cursor-pointer"
  (click)="popover.toggle($event)"
>
  @if (!isReadAll) {
  <i class="icon-wl-notification text-6" pBadge severity="danger"></i>
  } @else {
  <i class="icon-wl-notification text-6"></i>
  }

  <p-popover #popover styleClass="notification-popover" (onShow)="onPopoverShow()">
    <div
      class="flex flex-col w-[340px] sm:w-[400px] pt-6 pb-3 max-h-[460px] sm:max-h-[640px] overflow-y-auto"
      (scroll)="onNotificationScroll($event)"
    >
      <div class="flex justify-between px-5 pb-1.5">
        <span class="font-semibold text-4">{{ TRANSLATE_PREFIX + 'NOTIFICATION' | translate }}</span>
        @if(!isReadAll){
        <span class="font-medium text-primary-600 cursor-pointer" (click)="onMaskAllAsRead()">{{
          TRANSLATE_PREFIX + 'MARK-AS-READ' | translate
        }}</span
        >}
      </div>
      @for (notification of notifications; track $index) {
      <div class="pt-3">
        <span class="font-medium text-gray-600 text-2 px-5 pb-1"
          >{{
            isToday(notification.date || '') ? ('TIME.TODAY' | translate) : (notification.date | date: 'dd/MM/yyyy')
          }}
        </span>
        <ul class="list-none p-0 m-0 flex flex-col">
          @for (subNotification of notification.notifications; track subNotification.id) {
          <li
            class="flex items-start gap-2 cursor-pointer py-3 pr-5 relative"
            [ngClass]="{
              'bg-blue-100 hover:bg-blue-200': !subNotification?.is_read,
              'bg-white hover:bg-blue-50': subNotification?.is_read
            }"
            (click)="
            onNavigate(
              subNotification?.module_type || '',
              subNotification?.id || '',
              subNotification?.to_user,
              subNotification?.sender_user,
              subNotification?.notification_type,
              subNotification?.customer_id,
              subNotification?.exploit_id,
              subNotification?.send_time
            );
              onNavigateV2(subNotification)
            "
          >
            <div class="flex items-center gap-1.5 pl-2" [ngClass]="{ 'pl-5': subNotification?.is_read }">
              @if (!subNotification?.is_read) {
              <div class="w-1.5 h-1.5 rounded-full bg-blue-500"></div>
              } @if(subNotification?.sender_user){
              <app-custom-avatar
                [imgId]="subNotification?.sender_user?.image_url"
                size="md"
                [name]="subNotification?.sender_user?.full_name || ''"
              ></app-custom-avatar>
              } @else{
              <i
                class="
                  icon-wl-notification
                  text-5 text-primary-700
                  bg-primary-200
                  w-8
                  h-8
                  rounded-full
                  flex
                  items-center
                  justify-center
                "
              ></i>
              }
            </div>

            <div
              class="flex flex-col justify-center w-0 flex-1 leading-snug min-w-0"
              [pTooltip]="getPlainText(subNotification?.content || '')"
              tooltipPosition="bottom"
              showDelay="600"
              hideDelay="300"
              tooltipStyleClass="max-w-xs min-w-[150px] w-[340px] sm:w-[450px] whitespace-normal break-words text-left text-white rounded-lg"
            >
              <div
                [innerHTML]="sanitizeContent(subNotification?.content || '')"
                class="pointer-events-none line-clamp-2 leading-6 text-ellipsis overflow-hidden"
              ></div>
            </div>

            <div class="flex items-center text-xs text-gray-500 pl-2 whitespace-nowrap">
              <span>
                {{ subNotification.send_time ? (subNotification.send_time | timeAgo) : '' }}
              </span>
            </div>
          </li>

          }
        </ul>
      </div>
      }

      @if (isLoadingMore) {
      <div class="flex justify-center py-3">
        <i class="pi pi-spinner pi-spin text-gray-400"></i>
      </div>
      } @if (!hasMore && notifications.length > 0 && !isLoadingMore) {
      <div class="text-center text-2 text-gray-400 py-2">
        {{ TRANSLATE_PREFIX + 'NO-MORE' | translate }}
      </div>
      } @if (!isLoadingMore && notifications.length === 0) {
      <div class="text-center text-2 text-gray-400 py-6">
        {{ 'COMMON.NO_ITEMS' | translate }}
      </div>
      }
    </div>
  </p-popover>
</div>